export default __webpack_public_path__ + "static/media/setion03_kv02_m.9e45eb29.png";